// extracted by mini-css-extract-plugin
module.exports = {"social":"SocialLink_social__Ja4Dn","social__link":"SocialLink_social__link__27GWd","social__link__particles":"SocialLink_social__link__particles__B77r1"};